<template>
  <div class="bindDeviceWrap" v-loading="loading">
    <text-tip v-if="tipShow" class="textTip" @closeTip="closeTip">
      <div>自定义设备标识: 是用户自定义的用于标识一台设备的字符串。为方便您管理和记忆设备，您可以使用设备型号、IP地址、设备所处地理位置等信息的组合作为自定义设备标识。</div>
    </text-tip>
    <div>
      <div style="font-size:14px;font-weight:bold;margin-bottom:10px">请输入设备信息</div>
      <el-form ref="fileForm">
         <el-form-item label="设备信息文件" prop="deviceInfoFile" style="margin-bottom:10px;" required>
            <el-upload ref="excelUpload" :limit="1" :show-file-list="false" style="display:inline-block" :auto-upload="false" :on-change="handleChange" action="#">
              <el-button type="primary" icon="el-icon-upload2" style="margin-left:12px">选择文件</el-button>
            </el-upload>
            <div class="progress-style" v-if="fileName">
              <el-row>
                <el-col :span="8">             
                  <el-tooltip effect="dark" placement="top" :content="fileName">
                    <span style="font-size:12px;color:#333;">{{fileName.length<15?fileName:fileName.substring(0,14)+'...'}}</span>
                  </el-tooltip>              
                </el-col>
                <el-col :span="16"><el-progress :percentage="progressPercent" :text-inside="false" :stroke-width="3" style="margin-top:8px;"></el-progress></el-col>
              </el-row>  
              <div>
                <el-upload ref="excelUpload" :limit="1" :show-file-list="false" style="display:inline-block" :auto-upload="false" :on-change="handleChange" action="#">
                  <span style="cursor:pointer;color:#961189;font-size:12px;">重新上传</span>
                </el-upload>
                <!-- <span style="cursor:pointer;margin-left:10px;color:#961189;font-size:12px;" @click="deleteUpload">删除</span> -->
              </div>  
            </div>      
        </el-form-item>
        <el-form-item label="设备标识" prop="selfDefine" style="margin-bottom:10px">
          <span v-if="!fileName" style="margin-left:35px">--</span>
          <el-tooltip effect="dark" placement="top" :content="fileName" v-else>
            <span style="font-size:12px;color:#333;margin-left:35px">{{fileName.length<25?fileName:fileName.substring(0,24)+'...'}}</span>
          </el-tooltip> 
        </el-form-item> 
      </el-form>
    </div>
    <div class="operateClass">
      <div>
        <el-button type="primary" @click="add" :disabled="adding">新增</el-button>
        <el-button type="primary" plain @click="remove">移除</el-button>
      </div>
    </div>
    <table-form
      ref="tableForm"
      class="tableForm"
      :cols="cols"
      :colVails="colVails"
      :formTable="formTable"
      :row-key="getRowKey"
      :config="config"
      @selection-change="handleSelectionChange"
    >
      <template v-slot:deviceTag="slotData">
        <div>{{ slotData.row.deviceTag ||'--' }}</div>
      </template>
      <template v-slot:licenseNo="slotData">
        <el-form-item v-if="!slotData.row.id" label="" class="licenseKey" :prop="`data.${slotData.index}.licenseNo`" :rules="colVails['licenseNo']">
          <div class="authCodeItem">
            <el-input v-model="slotData.row.licenseNo">
            </el-input>
            <el-tooltip class="item" effect="dark" offset="10" content="追加" placement="top-start">
              <el-button plain @click="saveCode(slotData.formRef, slotData)" icon="el-icon-plus" style="padding:8px;margin-right:-6px;margin-left:3px"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" offset="10" content="取消" placement="top-start">
              <el-button plain @click="deleteCode(slotData)" icon="el-icon-minus" style="padding:8px"></el-button>
            </el-tooltip>
          </div>
        </el-form-item>
        <div v-else>{{ slotData.row.licenseNo }}</div>
      </template>
      <template v-slot:effectiveDays="slotData">
        <div>{{ slotData.row.effectiveDays == -1?'永久':slotData.row.effectiveDays }}</div>
      </template>
    </table-form>
    <dialog-common
      v-if="dialogCommon"
      :visible.sync="dialogCommon"
      title="提示"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose">
        <img width="16" height="16" style="margin-right: 8px;" src="../../../assets/img/warn.svg"  alt="">
        <span>您确认要移除选中项吗？</span>
    </dialog-common>
  </div>
</template>
<script>
import tableForm from '~/components/table-form-zgy.vue';
import textTip from '~/components/text-tip-zgy.vue';
import DialogCommon from "./Dialog/DialogCommon.vue";
import zgyLicenseReq from '~/request/zgyLicenseReq';
export default {
  components: {
    tableForm,
    textTip,
    DialogCommon
  },
  data() {
    return {
      loading: false,
      dialogCommon: false,
      customDeivceError: {},
      customDeivceInfo: [],
      currentCheck: [], // 当前整个表格选中
      isShow: false,
      currentRow: {}, // 单个行或者当前页选中的
      dialogInfoFlag: false, // 信息录入弹窗
      tipShow: true,
      colVails: {
        licenseNo: [
          { required: true, message: '授权码不能为空', trigger: ['blur'] },
          { validator: this.licenseKeyValidate, trigger: 'blur' },
        ],
      },
      cols: [
        { label: '设备标识', prop: 'deviceTag', minWidth: '230', slotName: 'deviceTag', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码', prop: 'licenseNo', minWidth: '360', slotName: 'licenseNo', 'show-overflow-tooltip': true, sortable: true },
        { label: '软件条码', prop: 'licenseSn', minWidth: '200', 'show-overflow-tooltip': true, sortable: true },
        { label: '产品型号', prop: 'displayFeatureName', minWidth: '110', 'show-overflow-tooltip': true, sortable: true },
        { label: '产品描述', prop: 'chineseDesc', minWidth: '130', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码状态', prop: 'licenseStatusName', minWidth: '110', 'show-overflow-tooltip': true, sortable: true },
        { label: '授权码类型', prop: 'licenseTypeName', minWidth: '110', 'show-overflow-tooltip': true, sortable: true },
        { label: '剩余有效时限（天）', prop: 'effectiveDays', minWidth: '160', slotName: 'effectiveDays', 'show-overflow-tooltip': true, sortable: true },
      ],
      formTable: {
        data: [],
      },
      config: {
        selection: {
          'reserve-selection': true,
        },
      },
      licenseKeyList: null,
      rowIds: null,
      isBatch: false, // 是否批量 false为不批量，true为批量
      deviceName: '', // 设备名称
      progressPercent:0,
      fileName:'',
      adding:false
    };
  },
  created(){
   this.refreshData();
  },

  methods: {
    //勾选列表
    handleSelectionChange(selection) {
      this.currentCheck = selection;
    },
    //刷新列表
    refreshData(){
      const defaultParam = {
        processNo:sessionStorage.getItem('processNo'),
        currentStep:2,
        page:1,
        size:999
      };
      zgyLicenseReq.getList(defaultParam).then(res=>{
        if(res.status){
          this.formTable.data = res.res.data;
          if(this.formTable.data.length && this.formTable.data[0].deviceTag){
            this.fileName = this.formTable.data[0].deviceTag;
            this.progressPercent = 100;
          }
        }
      })
    },
    //上传文件
    handleChange(file){
      this.deleteUpload();
      this.fileName = file.name;
      let formData = new FormData();
      formData.append('deviceFile',file.raw,file.name);
      let params = {
        processNo:sessionStorage.getItem('processNo'),
        tag:file.name
      };
      this.progressPercent = 50;
      zgyLicenseReq.inputDevice(formData,params).then(res => {
        if(res.status){
          this.progressPercent = 100;
          this.$notify({
            title: '成功',
            message: '录入成功',
            type: 'success',
          });
          this.refreshData();
        }else{
          this.$notify({
            title: '失败',
            message: res.msg,
            type: 'error',
          });
        }
      })
    },
    //删除上传
    deleteUpload(){
      this.fileName = '';
      if(this.$refs.excelUpload)this.$refs.excelUpload.clearFiles();
    },
    getRowKey(row) {
      return row.id || row.rowId;
    },
    //下一步验证
    getVail() {
      return new Promise((resovle, reject) => {
        return resovle();
      });
    },
    //	1LGXU9JV-y0t@3ahj-Ed@sOHd8-/b/C$Nja
    
    //新增插入一条数据
    add() {
      this.adding = true;
      let row = {
        licenseNo: '',
        deviceTag: this.fileName
      };
      this.formTable.data.unshift(row);
    },
    //真实追加
    saveCode(formRef, slotData) {
       let param = {
        processNo: sessionStorage.getItem('processNo'),
        licenseNo: slotData.row.licenseNo,
      };
      this.loading = true;
      zgyLicenseReq
        .addAuthCode(param.processNo, param.licenseNo, '2')
        .then(res => {
          this.loading = false;
          if (res.status) {
            this.adding = false;
            this.$notify({
              title: '成功',
              message: res.msg || '新增成功',
              type: 'success',
            });
            this.refreshData();
          } else {
            this.$notify({
              title: '失败',
              message: res.msg || '操作失败',
              type: 'error',
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
              title: '失败',
              message:'操作失败',
              type: 'error',
            });
        });
    },
     //取消
    deleteCode({ row, index }) {
      this.adding = false;
      this.formTable.data.splice(index, 1);
    },
    //点击大移除
     remove() {
      let currentCheck = [];
      this.currentCheck.forEach(item =>{
        if(item.licenseNo){
          currentCheck.push(item.licenseNo)
        }
      })
      if (!currentCheck.length) {
        this.$notify({
          title: '提示',
          message: '请至少选择一个有效的授权码！',
          type: 'warning',
        });
        return;
      }
      this.dialogCommon = true;
    },
    //取消移除弹框
    handleClose(){
      this.dialogCommon = false;
    },
    //确定删除
    handleConfirm(){
      let currentCheck = [];
      this.currentCheck.forEach(item =>{
        if(item.licenseNo){
          currentCheck.push(item.licenseNo)
        }
      })
      if(currentCheck.length){
        const param = {
          processNo: sessionStorage.getItem('processNo'),
          licenseNos: currentCheck,
        };
        zgyLicenseReq.remove(param).then(res => {
          this.loading = false;
          if (res.code == '0') {
            this.$notify({
              title: '成功',
              message: res.msg || '操作成功',
              type: 'success',
            });
            this.handleClose()
            this.refreshData();
          }
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        });
      }
    },
    closeTip() {
      this.tipShow = false;
    },
  },
};
</script>
<style lang="less" scoped>
.progress-style{
  margin:15px 0 10px 97px;
  border:1px solid #ddd;
  width:350px;
  padding:20px;
}
.bindDeviceWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .textTip {
    margin-bottom: 15px;
  }
  .operateClass {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    border-top:1px solid #eee;
    padding-top:10px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  // .el-form-item.licenseKey.is-error {
  //   padding-bottom: 28px;
  // }
  .licenseKey {
    .authCodeItem {
      display: flex;
      align-items: center;
      .inputImgWrap {
        padding-top: 3px;
      }
      .inputImgClass {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      .saveImg {
        margin-left: 12px;
      }
      .deleteImg {
        margin-left: 10px;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 44px;
      }
    }
    /deep/ .el-form-item__error{
      position: relative;
    }
  }
  .deviceName {
    .inputImgWrap {
      padding-top: 6px;
      .inputImgClass {
        width: 14px;
        height: 15px;
        cursor: pointer;
      }
      .disableClass {
        cursor: not-allowed;
      }
    }
    .customDeivceErrorClass {
      width: 100%;
      white-space: normal;
      font-size: 12px;
      color: #f56c6c;
      line-height: 1;
      margin-top: 4px;
    }
  }
  .productCode{
    cursor: pointer;
    color: @currentColor;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
// .authCodeInput /deep/ .el-form-item.is-error{
//   padding-bottom: 30px;
// }
// .tableForm /deep/ .el-input--small .el-input__inner{
//       height: 25.6px;
//       line-height: 25.6px;
//     }
</style>
